export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/FAQsIcon.f22b2925.svg","height":23,"width":26,"blurWidth":0,"blurHeight":0};